import type { ReactNode } from 'react';

import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';

const useStyles = createUseStyles({
    link: {
        fontSize: 15,
        '&:hover': {
            textDecoration: 'underline !important',
        },
    },
});

type DiagnosticLinkProps = {
    children: ReactNode;
    diagnosticId?: string;
    vin?: string;
};

export function DiagnosticLink({ children, diagnosticId, vin }: DiagnosticLinkProps) {
    const classes = useStyles();

    return (
        <Link className={classes.link} rel="noopener noreferrer" target="_blank" to={`/vin/${vin}/cvt/${diagnosticId}`}>
            {children}
        </Link>
    );
}
